import React from 'react';

import { SnackbarProvider } from 'components/theme/snackbar';
import { LoaderProvider } from 'components/theme/loader';
import componentUtil from 'utils/component';

export default function withInitialProvider(Component) {
  const WithInitiallProvider = (props) => {
    return (
      <>
        <LoaderProvider />
        <SnackbarProvider />
        <Component {...props} />
      </>
    );
  };
  WithInitiallProvider.displayName = componentUtil.getDisplayName(
    Component,
    'WithInitiaProvider'
  );
  return WithInitiallProvider;
}
